export enum EXPERIENCE_ACCESS_MODE {
  BOOK_AHEAD = 'BOOK_AHEAD',
  BOOK_ON_SITE = 'BOOK_ON_SITE',
  WALK_IN = 'WALK_IN',
}

export type ExperienceAccessMode =
  (typeof EXPERIENCE_ACCESS_MODE)[keyof typeof EXPERIENCE_ACCESS_MODE];
